





































































































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { CREDIT_LEVELS } from '@/constants/business';

@Component({
  computed: {
    ...mapState('Auth', {
      user: 'user',
      roles: 'roles',
      activeRoleKey: 'activeRoleKey',
      businesses: 'businesses',
      activeBusiness: 'activeBusiness',
    }),
    ...mapGetters('Auth', {
      business_credit_level: 'business_credit_level',
    }),
  },
})
export default class QRoleSwitcher extends Vue {
  user!: Model;
  roles!: Record<string, string>;
  activeRoleKey!: string;
  businesses!: Model[];
  business_credit_level!: Model[];
  activeBusiness!: Model;

  creditLevels = CREDIT_LEVELS;

  get availableBusinesses() {
    if (!this.roles) {
      return [];
    }

    return this.businesses.map((business) => {
      return {
        name: business.name,
        object_id: business.object_id,
        thumbnail: '',
      };
    });
  }

  get isAdminRole() {
    return this.activeRoleKey === 'rAdmin';
  }

  get isBusinessRole() {
    return this.activeRoleKey === 'rBusiness';
  }

  get isCandidateRole() {
    return this.activeRoleKey === 'rCandidate';
  }

  get hasAdminRole() {
    return Object.keys(this.roles).includes('rAdmin');
  }

  get hasBusinessRole() {
    return Object.keys(this.roles).includes('rBusiness');
  }

  get hasCandidateRole() {
    return Object.keys(this.roles).includes('rCandidate');
  }

  get userName() {
    if (!this.user) {
      return '';
    }
    return this.user.name + ' ' + this.user.surname;
  }

  setAdmin() {
    this.$store.commit('Auth/SET_ACTIVE_ROLE', 'rAdmin');
    this.goDashboard();
  }

  async setBusiness(item) {
    // Due to active business information stored with user details, once administrator decides the credit check result,
    // the frontend business user cannot received the updates from the backend.
    // The active business information stored in Vuex should be updated.
    // For a quick fix, we await the action of fetching user details.
    // So that vuex can have the latest business credit check information.
    // Further optimization is required.
    this.$store.commit('BusinessTag/RESET_STATE');
    await this.$store.dispatch('Auth/fetchUser');
    this.$store.commit('Auth/SET_ACTIVE_ROLE', 'rBusiness');
    this.$store.commit('Auth/SET_ACTIVE_BUSINESS', item.object_id);
    this.goDashboard();
  }

  setCandidate() {
    this.$store.commit('Auth/SET_ACTIVE_ROLE', 'rCandidate');
    this.goDashboard();
  }

  handleLogout() {
    this.$store.dispatch('Auth/logout', this.activeRoleKey);
  }

  goProfile() {
    const activeRoleKey = this.activeRoleKey;
    let routeName = 'login';
    switch (activeRoleKey) {
      case 'rAdmin':
        routeName = 'administrator-user-profile';
        break;
      case 'rBusiness':
        routeName = 'business-user-profile';
        break;
      case 'rCandidate':
        routeName = 'candidate-user-profile';
        break;
      default:
        break;
    }
    this.$router.push({
      name: routeName,
    });
  }

  goBusinessCreate() {
    this.$router.push({
      name: 'business-create',
    });
  }

  goDashboard() {
    let routeName = 'dashboard';
    switch (this.activeRoleKey) {
      case 'rAdmin':
        routeName = 'administrator-dashboard';
        break;
      case 'rBusiness':
        routeName = 'business-dashboard';
        break;
      case 'rCandidate':
        routeName = 'candidate-dashboard';
        break;
      default:
        break;
    }

    // If current route is not dashboard, go to specific dashboard based on the user role,
    // else force reloading the page
    if (this.$route.name != routeName) {
      this.$router.replace({ name: routeName });
    }

    this.$router.go(0);
  }
}
